import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";
import {
  CONTACT_REDUCER_PATH,
  CONTACT_RELATED_TAGS,
} from "@/modules/contacts/utils/contact-service-tags";

export const contactService = createApi({
  reducerPath: CONTACT_REDUCER_PATH,
  tagTypes: CONTACT_RELATED_TAGS,
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: onPrepareHeaders,
  }),
  endpoints: () => ({}),
});

